import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Inbox, ArrowLeft } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import GymRequestsManager from './GymRequestsManager';

export default function GymRequestsPage() {
  const { t } = useTranslation();
  const { isAdmin } = useAuth();

  if (!isAdmin()) {
    return <Navigate to="/admin/gyms" replace />;
  }

  return (
    <div className="p-4 sm:p-6 bg-gray-50 dark:bg-gray-900 min-h-screen w-full">
      <div className="w-full max-w-7xl mx-auto">
        <div className="mb-4 sm:mb-6">
          <Link
            to="/admin/gyms"
            className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white mb-2 transition-colors"
          >
            <ArrowLeft size={16} />
            {t('admin.gymManager.backToList')}
          </Link>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-3">
            <Inbox className="text-amber-600 shrink-0" />
            {t('admin.gymRequests.title')}
          </h1>
          <p className="text-gray-600 dark:text-gray-300 mt-1 text-sm sm:text-base max-w-3xl">
            {t('admin.gymRequests.description')}
          </p>
        </div>

        <GymRequestsManager />
      </div>
    </div>
  );
}
